import { Link } from 'gatsby'
import { useMobile } from 'src/hooks/useMobile'

import { CallToAction } from '../../campaign/common/CallToAction'
import { renderImage } from '.'
import type { Banner } from './index'

type SecondaryBannerProps = {
  secondaryBanner: Banner[]
}

const SecondaryBanner = ({ secondaryBanner }: SecondaryBannerProps) => {
  const { screenWidth } = useMobile()

  return (
    <div className="flex flex-col containerBanner">
      {secondaryBanner.map((banner, index) => {
        const title = banner?.title
        const text = banner?.text
        const priceContainer = banner?.priceContainer
        const cta = banner?.cta
        const linkURL = banner?.linkURL
        const images = banner?.images
        const backgroundColorContainer = banner?.backgroundColor

        return (
          <Link
            key={index}
            style={{
              backgroundImage: `url(${renderImage(images, screenWidth)})`,
            }}
            to={linkURL || '#'}
            className="bannerPromotionItem"
          >
            <div
              className="containerTextPromotion px-5 py-4"
              style={{
                backgroundColor: backgroundColorContainer ?? '#FFF',
              }}
            >
              <h2 style={{ color: title?.fontColor ?? '#000' }}>
                {title?.text}
              </h2>
              <h4 style={{ color: text?.fontColor ?? '#000' }}>{text?.body}</h4>
              <div className="flex justify-between items-end">
                {priceContainer?.enable && priceContainer ? (
                  <div className="ctaPromotion">
                    <p
                      style={{
                        color: priceContainer?.fontColor ?? '#000',
                      }}
                    >
                      {priceContainer?.subtitlePrice}
                    </p>
                    <h5
                      style={{
                        color: priceContainer?.fontColor ?? '#000',
                      }}
                    >
                      {priceContainer?.price}
                    </h5>
                  </div>
                ) : (
                  <div />
                )}
                {cta?.enable && cta ? (
                  <CallToAction
                    link={linkURL}
                    text={cta?.text}
                    fontColor={cta?.fontColor}
                    backgroundColor={cta?.backgroundColor}
                    hover="#F7F8F9"
                  />
                ) : (
                  <div />
                )}
              </div>
            </div>
          </Link>
        )
      })}
    </div>
  )
}

export default SecondaryBanner
